/* eslint-disable no-use-before-define */
import React from 'react'
import { isCusip, Status} from '../twd/twd'

export default () => {

    const [errors, setErrors] = React.useState({})

    const validate = ({
        cusip, action, isRfq, qty, price, yld, priceOrYield,
        orderInfoStatus, isChangeToRfq, hasMarket, isRestricted,
        isTreasuryAuction,
        isSkipErrors
    }) => {
        if (!isSkipErrors && orderInfoStatus !== Status.LOADED) {
            setErrors({})
            return true
        }

        const errs = {}

        if (!isCusip(cusip)) {
            errs.cusip = isRfq
                ? "Please enter a valid CUSIP"
                : "Please enter a valid CUSIP, symbol or company name"
        }

        if (!action) {
            errs.action = "Please select an action"
        }

        const q = parseFloat(qty)
        if (!isRestricted && (isNaN(q) || q<=0)) {
            errs.qty = "Please enter a quantity"
        }

        if (!isTreasuryAuction) {
            const rfq = isRfq || isChangeToRfq || !hasMarket
            const p = parseFloat(price)
            if (!rfq && priceOrYield===1 && (isNaN(p) || p<=0)) {
                errs.price = "Please enter a price"
            }

            const y = parseFloat(yld)
            if (!rfq && priceOrYield===0 && isNaN(y)) {
                errs.yld = "Please enter a yield"
            }
        }

        if (!isSkipErrors) {
            setErrors(errs)
        }

        return Object.keys(errs).length === 0
    }

    const reset = () => {
        setErrors({})
    }

    return {
        errors, setErrors,
        validate,
        reset,
    }

}
